import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface HoldingsSearch {
  corporateNumber: string;
  name: string;
  timestamp: number;
}

const initialState = {} as HoldingsSearch;

const searchConditionSlice = createSlice({
  name: "holdings",
  initialState,
  reducers: {
    createSearchCondition: (state, action: PayloadAction<HoldingsSearch>) => {
      const { corporateNumber, name, timestamp } = action.payload;
      state.corporateNumber = corporateNumber;
      state.name = name;
      state.timestamp = timestamp;
    },
  },
});

export const { createSearchCondition } = searchConditionSlice.actions;

export default searchConditionSlice.reducer;
